module.exports = __webpack_public_path__ + "img/404-1.0605f444.svg";